import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";

const AddSeasonDialog = ({ open, seasonName, onChangeSeasonName, onClose, onConfirm }) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
    <DialogTitle>Adicionar temporada</DialogTitle>
    <DialogContent>
      <TextField
        autoFocus
        margin="dense"
        label="Nome da temporada"
        fullWidth
        value={seasonName}
        onChange={(event) => onChangeSeasonName(event.target.value)}
      />
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancelar</Button>
      <Button variant="contained" onClick={onConfirm}>
        Adicionar
      </Button>
    </DialogActions>
  </Dialog>
);

export default AddSeasonDialog;

